import { defineMessage } from 'services/localization';

export const messages = {
    knowledgeBaseActivator: defineMessage('knowledge_base'),
    videosActivator: defineMessage('howto_videos'),
    trainingActivator: defineMessage('training_package'),
    hideButton: defineMessage('hide'),
};
